
export default function Logo() {
    return (
        <div className="col-12 lg:col-4 h-full pb-0">
            <div className="grid h-full">
                <div className='col-12 h-full pb-0'>
                    <img src="/img/logo.png" className='h-full'></img>
                </div>
            </div>
        </div>
    )
}